export enum ContactInteractionDirection {
  OUTBOUND = 'OUTBOUND',
  INBOUND = 'INBOUND',
}
